import React from 'react';
import { MetaCompartilhada } from '../services/api';
import { AcoesDaMeta, MetaCompartilhadaCard } from './MetaCompartilhadaCard';

/**
 * Uma vaquinha de mentira, para mostrar como fica antes de criar (05/10).
 *
 * Aparece quando ela toca em "+ Juntar dinheiro com alguém" e ainda não tem
 * nenhuma meta compartilhada: o formulário pede um nome e um valor, e não
 * mostrava no que aquilo ia dar.
 *
 * ── O card é o DE VERDADE ────────────────────────────────────────────────
 *
 * `MetaCompartilhadaCard` com dados inventados, e não uma cópia da marcação:
 * o exemplo muda sozinho quando o card mudar. As ações são vazias e o bloco
 * fica `inert` — esmaecer só tira o mouse, e sem isto o Tab entraria num
 * "Guardar dinheiro" que não guarda nada.
 *
 * Quatro pessoas em estados diferentes de propósito: quem pôs muito, quem pôs
 * pouco e quem "ainda não" (que é `null`, não zero — ver `MembroDaMeta`).
 */
const META_DE_EXEMPLO: MetaCompartilhada = {
  id: 'exemplo',
  nome: 'Viagem Japão 2028',
  alvo: 30000,
  prazoMes: null,
  total: 9200,
  meu: 4000,
  souDona: true,
  membros: [
    { userId: 'exemplo-1', nome: 'Você', eu: true, valor: 4000 },
    { userId: 'exemplo-2', nome: 'Ana', eu: false, valor: 3200 },
    { userId: 'exemplo-3', nome: 'Lucas', eu: false, valor: 2000 },
    { userId: 'exemplo-4', nome: 'Bia', eu: false, valor: null },
  ],
  convites: [],
};

const nada = async () => { /* exemplo: nenhuma ação faz nada */ };
const SEM_ACAO: AcoesDaMeta = {
  aportar: nada, convidar: nada, cancelarConvite: nada, sair: nada, encerrar: nada,
};

const ExemploDeMetaCompartilhada: React.FC<{ fmt: (v: number) => string }> = ({ fmt }) => (
  <div className="empty-preview-wrap meta-exemplo">
    <span className="empty-preview-badge">Exemplo</span>
    {/* `inert` ainda não está nos tipos do React desta versão; como atributo
        cru o navegador entende do mesmo jeito. */}
    <div className="empty-preview-ghost" aria-hidden="true" {...{ inert: '' }}>
      <MetaCompartilhadaCard meta={META_DE_EXEMPLO} acoes={SEM_ACAO} fmt={fmt} abertoDeInicio />
    </div>
    <div className="empty-cta">
      <p className="empty-cta-title">É assim que fica</p>
      <p className="empty-cta-sub">
        Cada pessoa guarda o que pode, quando pode, e todo mundo vê o total andar.
        Depois de criar, você chama quem vai juntar com você.
      </p>
    </div>
  </div>
);

export default ExemploDeMetaCompartilhada;
